import { action } from 'typesafe-actions';
import { BandedOrCriteriaMarksObject, QuickMarkLibrary, TotalScoresInfo } from './reducer';
import { QuickMarkType } from '../../store/common/constants';
import { QuickMarkOrComment } from '../../store/common/features/types';
import { CommentTypes } from '../commentsList/services/commentsService';
import { CriteriaLibraries } from '../../services/setMarksServices';

export enum TypeKeys {
    SET_SCORE_SUCCESS = 'setMark/SET_SCORE_SUCCESS',
    CALL_SET_SCORE = 'setMark/CALL_SET_SCORE',
    CALL_RESET_SCORE = 'setMark/CALL_RESET_SCORE',
    CHANGE_SCORE = 'setMark/CHANGE_SCORE',
    SET_SCORE_DATA = 'setMark/SET_SCORE_DATA',
    SET_DECIMAL_INPUT = 'setMark/SET_DECIMAL_INPUT',
    SET_AUTOMATIC_SCORE_MODE = 'setMark/SET_AUTOMATIC_SCORE_MODE',
    TOGGLE_PROCESSING_FLAG = 'setMark/TOGGLE_PROCESSING_FLAG',
    SET_FLAG_USER_QUESTION = 'setMark/SET_FLAG_USER_QUESTION',
    ENABLE_FORCE_FOCUS_VAR = 'setMark/ENABLE_FORCE_FOCUS_VAR',
    RESET_FORCE_FOCUS_VAR = 'setMark/RESET_FORCE_FOCUS_VAR',
    ON_BANDED_OR_CRITERIA_MARKS_LOADED = 'setMark/ON_BANDED_OR_CRITERIA_MARKS_LOADED',
    ON_RUBRICS_LOADED = 'setMark/ON_RUBRICS_LOADED',
    ON_SAVE_CRITERIA_SCORE = 'setMark/ON_SAVE_CRITERIA_SCORE',
    ON_CRITERIA_SCORE_SAVED = 'setMark/ON_CRITERIA_SCORE_SAVED',
    CANCEL_OVERRIDE = 'setMark/CANCEL_OVERRIDE',
    SET_OVERRIDE_MODE = 'setMark/SET_OVERRIDE_MODE',
    LOAD_QUICK_MARKS = 'setMark/LOAD_QUICK_MARKS',
    TOGGLE_QUICK_MARK = 'setMark/TOGGLE_QUICK_MARK',
    DELETE_QUICK_MARK = 'setMark/DELETE_QUICK_MARK',
    ADD_QUICK_MARK = 'setMark/ADD_QUICK_MARK',
    UPDATE_QUICK_MARK_TEXT = 'setMark/UPDATE_QUICK_MARK_TEXT',
    UPDATE_QUICK_MARK_SCORE = 'setMark/UPDATE_QUICK_MARK_SCORE',
    SAVE_QUICK_MARK = 'setMark/SAVE_QUICK_MARK',
    SET_SCORE_AS_OVERRIDDEN = 'setMark/SET_SCORE_AS_OVERRIDDEN',
    TOTAL_SCORES_LOADED = 'setMark/TOTAL_SCORES_LOADED',
    SET_SCORE_TRANSITION_STATE = 'setMark/SET_SCORE_TRANSITION_STATE',
    QUICK_MARKS_LIBRARIES_LOADED = 'setMark/QUICK_MARKS_LIBRARIES_LOADED',
    QUICK_MARK_LIBRARY_SELECTED = 'setMark/QUICK_MARK_LIBRARY_SELECTED',
    QUICK_MARK_LIBRARY_DESELECTED = 'setMark/QUICK_MARK_LIBRARY_DESELECTED',
    UPDATE_QUICK_MARK_LIBRARY = 'setMark/UPDATE_QUICK_MARK_LIBRARY',
    ON_EVALUATOR_TAB_SELECTED = 'setMark/ON_EVALUATOR_TAB_SELECTED',
    ON_QUICK_MARK_CHANGED_PUSH_NOTIFICATION = 'setMark/ON_QUICK_MARK_CHANGED_PUSH_NOTIFICATION',
    EDIT_ANSWER_KEYS = 'setMark/EDIT_ANSWER_KEYS',
    SET_USER_RESPONSE_MIMETYPE = 'setMark/SET_USER_RESPONSE_MIMETYPE',
    SET_QUESTION_VALIDATION_ISSUE_REVIEWED = 'setMark/SET_QUESTION_VALIDATION_ISSUE_REVIEWED',
}

export interface UpdateQuickMarkTextAction {
    type: TypeKeys.UPDATE_QUICK_MARK_TEXT;
    featureId: string;
    id: number;
    comment: string;
}

export interface UpdateQuickMarkScoreAction {
    type: TypeKeys.UPDATE_QUICK_MARK_SCORE;
    id: number;
    score: number;
    featureId: string;
}

export interface SaveQuickMarkAndCommentAction {
    type: TypeKeys.SAVE_QUICK_MARK;
    newText: string;
    quickMarkLibraryType: CriteriaLibraries;
    quickMarkLibraryId: number;
    newScore?: number;
    featureId: string;
}

export interface AddQuickMarkAction {
    type: TypeKeys.ADD_QUICK_MARK;
    quickMarkType: QuickMarkType;
    quickMarkLibraryType: CriteriaLibraries;
    quickMarkLibraryId?: number;
    featureId: string;
}

export interface DeleteQuickMarkAction {
    type: TypeKeys.DELETE_QUICK_MARK;
    id: number;
    featureId: string;
}

export interface ToggleQuickMarkAction {
    type: TypeKeys.TOGGLE_QUICK_MARK;
    id: number;
    featureId: string;
}

export interface LoadQuickMarksAction {
    type: TypeKeys.LOAD_QUICK_MARKS;
    data: QuickMarkOrComment[];
    featureId: string;
}

export interface SetScoreAsOverriddenAction {
    type: TypeKeys.SET_SCORE_AS_OVERRIDDEN;
    featureId: string;
}

export interface SetOverrideModeAction {
    type: TypeKeys.SET_OVERRIDE_MODE;
    isEnabled: boolean;
    featureId: string;
}

export interface CancelOverrideModeAction {
    type: TypeKeys.CANCEL_OVERRIDE;
    featureId: string;
}

export interface SetFlagUserQuestionAction {
    type: TypeKeys.SET_FLAG_USER_QUESTION;
    featureId: string;
}

export interface ToggleProcessingFlagAction {
    type: TypeKeys.TOGGLE_PROCESSING_FLAG;
    featureId: string;
}

export interface SetScoreSuccessAction {
    type: TypeKeys.SET_SCORE_SUCCESS;
    featureId: string;
}

export interface SetAutomaticScoreMode {
    type: TypeKeys.SET_AUTOMATIC_SCORE_MODE;
    featureId: string;
}

export interface SetDecimalInputAction {
    type: TypeKeys.SET_DECIMAL_INPUT;
    status: boolean;
    featureId: string;
}

export interface ResetScoreAction {
    type: TypeKeys.CALL_RESET_SCORE;
    featureId: string;
}

export interface SetScoreAction {
    type: TypeKeys.CALL_SET_SCORE;
    featureId: string;
}

export interface SetScoreDataAction {
    type: TypeKeys.SET_SCORE_DATA;
    featureId: string;
    scoreData: any;
}

export interface ChangeScoreAction {
    type: TypeKeys.CHANGE_SCORE;
    value: string;
    featureId: string;
}

export interface EnableForceFocusAction {
    type: TypeKeys.ENABLE_FORCE_FOCUS_VAR;
    featureId: string;
}

export interface ResetForceFocusAction {
    type: TypeKeys.RESET_FORCE_FOCUS_VAR;
    featureId: string;
}

export interface OnSaveCriteriaScoreAction {
    type: TypeKeys.ON_SAVE_CRITERIA_SCORE;
    score: number;
    featureId: string;
    criteriaId: string;
    criteriaType: CommentTypes;
    deleteGrading: boolean;
    allCriteriaMarked?: boolean;
    criterionFeedback?: string;
}

export interface BandedOrCriteriaMarksLoadedAction {
    type: TypeKeys.ON_BANDED_OR_CRITERIA_MARKS_LOADED;
    bandedOrCriteriaMarks: BandedOrCriteriaMarksObject;
    featureId: string;
}

export interface RubricsLoadedAction {
    type: TypeKeys.ON_RUBRICS_LOADED;
    rubrics: BandedOrCriteriaMarksObject;
    rubricItemId: number;
    featureId: string;
}

export interface TotalScoresLoadedAction {
    type: TypeKeys.TOTAL_SCORES_LOADED;
    featureId: string;
    totalScoresInfo: any;
}

export interface SetScoreTransitionStateAction {
    featureId: string;
    value: boolean;
    type: TypeKeys.SET_SCORE_TRANSITION_STATE;
}

export interface QuickMarksLibrariesLoadedAction {
    featureId: string;
    quickMarksLibraries: QuickMarkLibrary[];
    type: TypeKeys.QUICK_MARKS_LIBRARIES_LOADED;
}

export interface QuickMarksLibrarySelectedAction {
    featureId: string;
    quickMarkLibraryId: number;
    type: TypeKeys.QUICK_MARK_LIBRARY_SELECTED;
}
export interface QuickMarksLibraryDeselectedAction {
    featureId: string;
    quickMarkLibraryId: number;
    type: TypeKeys.QUICK_MARK_LIBRARY_DESELECTED;
}

export interface UpdateQuickMarkLibraryAction {
    featureId: string;
    quickMarkId: number;
    quickMarkLibraryId: number;
    type: TypeKeys.UPDATE_QUICK_MARK_LIBRARY;
}

export interface OnEvaluatorTabSelectedAction {
    featureId: string;
    selectedEvaluatorId: number;
    type: TypeKeys.ON_EVALUATOR_TAB_SELECTED;
}

export interface QuickMarkChangedPushNotificationAction {
    type: TypeKeys.ON_QUICK_MARK_CHANGED_PUSH_NOTIFICATION;
}

export interface EditAnswerKeys {
    featureId: string;
    type: TypeKeys.EDIT_ANSWER_KEYS;
}

export interface SetUserResponseMimeTypeAction {
    featureId: string;
    type: TypeKeys.SET_USER_RESPONSE_MIMETYPE;
    userResponseMimeType: string;
}

export interface SetQuestionValidationIssueReviewedAction {
    type: TypeKeys.SET_QUESTION_VALIDATION_ISSUE_REVIEWED;
    featureId: string;
    isReviewed: boolean;
}

export type ActionTypes = | SetScoreAction
                          | ResetScoreAction
                          | SetDecimalInputAction
                          | ChangeScoreAction
                          | SetScoreDataAction
                          | SetAutomaticScoreMode
                          | ToggleProcessingFlagAction
                          | SetFlagUserQuestionAction
                          | SetScoreSuccessAction
                          | EnableForceFocusAction
                          | ResetForceFocusAction
                          | BandedOrCriteriaMarksLoadedAction
                          | OnSaveCriteriaScoreAction
                          | CancelOverrideModeAction
                          | SetOverrideModeAction
                          | LoadQuickMarksAction
                          | ToggleQuickMarkAction
                          | DeleteQuickMarkAction
                          | AddQuickMarkAction
                          | UpdateQuickMarkTextAction
                          | UpdateQuickMarkScoreAction
                          | SaveQuickMarkAndCommentAction
                          | SetScoreAsOverriddenAction
                          | TotalScoresLoadedAction
                          | SetScoreTransitionStateAction
                          | QuickMarksLibrariesLoadedAction
                          | QuickMarksLibrarySelectedAction
                          | UpdateQuickMarkLibraryAction
                          | OnEvaluatorTabSelectedAction
                          | QuickMarksLibraryDeselectedAction
                          | EditAnswerKeys
                          | RubricsLoadedAction
                          | SetUserResponseMimeTypeAction
                          | SetQuestionValidationIssueReviewedAction;


export const setScoreTransitionState = (featureId: string, value: boolean): SetScoreTransitionStateAction => ({
    featureId,
    value,
    type: TypeKeys.SET_SCORE_TRANSITION_STATE,
});

export const saveQuickMarkAndComment = (featureId: string,
    newText: string,
    quickMarkLibraryType: CriteriaLibraries,
    quickMarkLibraryId?: number,
    newScore?: number,): SaveQuickMarkAndCommentAction => ({
    featureId,
    newText,
    quickMarkLibraryType,
    newScore,
    quickMarkLibraryId,
    type: TypeKeys.SAVE_QUICK_MARK,
});

export const updateCriteria = (featureId: string, id: number, score: number): UpdateQuickMarkScoreAction => ({
    featureId,
    id,
    score,
    type: TypeKeys.UPDATE_QUICK_MARK_SCORE,
});

export const updateComment = (featureId: string, id: number, comment: string): UpdateQuickMarkTextAction => ({
    featureId,
    id,
    comment,
    type: TypeKeys.UPDATE_QUICK_MARK_TEXT,
});

export const addQuickMark = (featureId: string,
    type: QuickMarkType,
    quickMarkLibraryType: CriteriaLibraries,
    quickMarkLibraryId?: number): AddQuickMarkAction => ({
    featureId,
    quickMarkLibraryType,
    quickMarkLibraryId,
    quickMarkType: type,
    type: TypeKeys.ADD_QUICK_MARK,
});

export const deleteQuickMark = (featureId: string, id: number): DeleteQuickMarkAction => ({
    featureId,
    id,
    type: TypeKeys.DELETE_QUICK_MARK,
});

export const toggleQuickMark = (featureId: string, id: number): ToggleQuickMarkAction => ({
    featureId,
    id,
    type: TypeKeys.TOGGLE_QUICK_MARK,
});

export const loadQuickMarks = (featureId: string, data: QuickMarkOrComment[]): LoadQuickMarksAction => ({
    featureId,
    data,
    type: TypeKeys.LOAD_QUICK_MARKS,
});

export const setScoreAsOverridden = (featureId: string): SetScoreAsOverriddenAction => ({
    featureId,
    type: TypeKeys.SET_SCORE_AS_OVERRIDDEN,
});

export const setOverrideMode = (featureId: string, isEnabled: boolean): SetOverrideModeAction => ({
    featureId,
    isEnabled,
    type: TypeKeys.SET_OVERRIDE_MODE,
});

export const cancelOverride = (featureId: string): CancelOverrideModeAction => ({
    featureId,
    type: TypeKeys.CANCEL_OVERRIDE,
});

export const setScoreSuccess = (featureId: string): SetScoreSuccessAction => ({
    featureId,
    type: TypeKeys.SET_SCORE_SUCCESS,
});

export const toggleProcessingFlag = (featureId: string): ToggleProcessingFlagAction => ({
    featureId,
    type: TypeKeys.TOGGLE_PROCESSING_FLAG,
});

export const setAutomaticScoreMode = (featureId: string): SetAutomaticScoreMode => ({
    featureId,
    type: TypeKeys.SET_AUTOMATIC_SCORE_MODE,
});

export const setDecimalInput = (featureId: string, status: boolean): SetDecimalInputAction => ({
    featureId,
    status,
    type: TypeKeys.SET_DECIMAL_INPUT,
});

export const setScore = (featureId: string): SetScoreAction => ({
    featureId,
    type: TypeKeys.CALL_SET_SCORE,
});

export const resetScore = (featureId: string): ResetScoreAction => ({
    featureId,
    type: TypeKeys.CALL_RESET_SCORE,
});

export const setScoreData = (featureId: string, scoreData: any): SetScoreDataAction => ({
    featureId,
    scoreData,
    type: TypeKeys.SET_SCORE_DATA,
});

export const changeScore = (featureId: string, value: string): ChangeScoreAction => ({
    featureId,
    value,
    type: TypeKeys.CHANGE_SCORE,
});

export const setFlagUserQuestion = (featureId: string): SetFlagUserQuestionAction => ({
    featureId,
    type: TypeKeys.SET_FLAG_USER_QUESTION,
});

export const enableForceFocus = (featureId: string): EnableForceFocusAction => ({
    featureId,
    type: TypeKeys.ENABLE_FORCE_FOCUS_VAR,
});

export const resetForceFocus = (featureId: string): ResetForceFocusAction => ({
    featureId,
    type: TypeKeys.RESET_FORCE_FOCUS_VAR,
});

export const onBandedOrCriteriaMarksLoaded = (featureId: string,
    bandedOrCriteriaMarks: BandedOrCriteriaMarksObject): BandedOrCriteriaMarksLoadedAction => ({
    featureId,
    bandedOrCriteriaMarks,
    type: TypeKeys.ON_BANDED_OR_CRITERIA_MARKS_LOADED,
});

export const onSaveCriteriaScore = (featureId: string,
    criteriaId: string,
    score: number,
    criteriaType: CommentTypes,
    deleteGrading: boolean,
    allCriteriaMarked?: boolean,
    criterionFeedback?: string): OnSaveCriteriaScoreAction => ({
    featureId,
    criteriaId,
    score,
    criteriaType,
    deleteGrading,
    allCriteriaMarked,
    criterionFeedback,
    type: TypeKeys.ON_SAVE_CRITERIA_SCORE,
});

export const onCriteriaScoreSaved = () => {
    return action(TypeKeys.ON_CRITERIA_SCORE_SAVED);
};

export const totalScoresLoaded = (featureId: string, totalScoresInfo: TotalScoresInfo): TotalScoresLoadedAction => ({
    featureId,
    totalScoresInfo,
    type: TypeKeys.TOTAL_SCORES_LOADED,
});

export const quickMarksLibrariesLoaded = (featureId: string, quickMarksLibraries: QuickMarkLibrary[]): QuickMarksLibrariesLoadedAction => ({
    featureId,
    quickMarksLibraries,
    type: TypeKeys.QUICK_MARKS_LIBRARIES_LOADED,
});

export const quickMarkLibrarySelected = (featureId: string, quickMarkLibraryId: number): QuickMarksLibrarySelectedAction => ({
    featureId,
    quickMarkLibraryId,
    type: TypeKeys.QUICK_MARK_LIBRARY_SELECTED,
});

export const quickMarkLibraryDeselected = (featureId: string, quickMarkLibraryId: number): QuickMarksLibraryDeselectedAction => ({
    featureId,
    quickMarkLibraryId,
    type: TypeKeys.QUICK_MARK_LIBRARY_DESELECTED,
});

export const updateQuickMarkLibrary = (featureId: string, quickMarkId: number, quickMarkLibraryId: number): UpdateQuickMarkLibraryAction => ({
    featureId,
    quickMarkId,
    quickMarkLibraryId,
    type: TypeKeys.UPDATE_QUICK_MARK_LIBRARY,
});

export const onEvaluatorTabSelected = (featureId: string, selectedEvaluatorId: number): OnEvaluatorTabSelectedAction => ({
    featureId,
    selectedEvaluatorId,
    type: TypeKeys.ON_EVALUATOR_TAB_SELECTED,
});
export const quickMarkChanged = (): QuickMarkChangedPushNotificationAction => ({
    type: TypeKeys.ON_QUICK_MARK_CHANGED_PUSH_NOTIFICATION,
});

export const editAnswerKeys = (featureId: string): EditAnswerKeys => ({
    featureId,
    type: TypeKeys.EDIT_ANSWER_KEYS,
});

export const onRubricsLoaded = (featureId: string, rubrics: BandedOrCriteriaMarksObject, rubricItemId?: number): RubricsLoadedAction => ({
    featureId,
    rubrics,
    rubricItemId,
    type: TypeKeys.ON_RUBRICS_LOADED,
});

export const setUserResponseMimeType = (featureId: string, userResponseMimeType: string): SetUserResponseMimeTypeAction => ({
    featureId,
    userResponseMimeType,
    type: TypeKeys.SET_USER_RESPONSE_MIMETYPE,
});

export const setQuestionValidationIssueReviewed = (featureId: string, isReviewed: boolean): SetQuestionValidationIssueReviewedAction => ({
    featureId,
    isReviewed,
    type: TypeKeys.SET_QUESTION_VALIDATION_ISSUE_REVIEWED,
});
